import { render, staticRenderFns } from "./cg-nav.vue?vue&type=template&id=0502b73b&scoped=true"
import script from "./cg-nav.vue?vue&type=script&lang=js"
export * from "./cg-nav.vue?vue&type=script&lang=js"
import style0 from "./cg-nav.vue?vue&type=style&index=0&id=0502b73b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0502b73b",
  null
  
)

export default component.exports